// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__2UPSL","dragIcon":"Choice_dragIcon__2efvj","left":"Choice_left__F3WPI","input":"Choice_input__35pMO"};